import { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import './ReactPdfViewer.scss';
interface ReactPdfViewerProps {
  pdfFile: string;  // Assuming pdfFile is a string (URL or file path)
  fieldBox?: any;    // Replace 'any' with the actual type if known
  pageNumber?: number;
  setPageNumber?: (pageNumber: number) => void; // Function to set page number
  bodyClass?: string; // Optional prop with default value
}

const ReactPdfViewer: React.FC<ReactPdfViewerProps> = ({
  pdfFile,
  fieldBox,
  pageNumber,
  setPageNumber,
  bodyClass = "pdf-viewer"
}) => {
  //const {pdfFile, fieldBox, pageNumber, setPageNumber, bodyClass="pdf-viewer"} = props
  const [numPages, setNumPages] = useState<number>(0);
  const [pageNum, setPageNum] = useState(1);
  const [topPosition, setTopPosition] = useState<number[]>([]);
  const [scaleShow, setScaleShow] = useState(false);  
  const parentRef = useRef<HTMLDivElement | null>(null);
  const mainScrollRef = useRef<HTMLDivElement | null>(null);
  const miniScrollRef =  useRef<HTMLDivElement | null>(null);
  const miniDivRef =  useRef<HTMLDivElement | null>(null);

  const pgno = pageNumber ?? pageNum;
  const setPgno = setPageNumber ?? setPageNum;

  useEffect(() => {
    // Manually set the worker source
    pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/js/pdf.worker.js`;
    //pdfjs.GlobalWorkerOptions.workerSrc = "/js/pdf-worker.js";
    //pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
   }, []);


   const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
    setTopPosition(Array(numPages).fill(0)); // Initialize topPosition array
};


const onPageLoadSuccess = (page: any, pageno: number, pg_height: number): void => {
  const positions: number[] = [];
  if (mainScrollRef.current) {
      const pageDivs = mainScrollRef.current.querySelectorAll<HTMLDivElement>('.react-pdf__Page');
      pageDivs.forEach((pageDiv) => {
          const rect = pageDiv.getBoundingClientRect();
          positions.push(rect.top - 80); // Add scrollY for accurate position
      });
  }
  setTopPosition(positions);
};

const handlePageSnippet = (pageno: number): void => {
  const top = topPosition[pageno - 1] - 4;
  if (mainScrollRef.current) {
      mainScrollRef.current.scrollTo({ top: top, behavior: 'auto' });
  }
  setPgno(pageno);
};
  function onLoadProgress(progress:any) {
    console.log('Loading progress:', progress);
  }

  const currentTopPosition = (): number[] => {
    const positions: number[] = [];
    if (mainScrollRef.current) {
        const pageDivs = mainScrollRef.current.querySelectorAll<HTMLElement>('.react-pdf__Page');
        pageDivs.forEach((pageDiv) => {
            const rect = pageDiv.getBoundingClientRect();
            positions.push(rect.top + window.scrollY); // Add scrollY for accurate position
        });
    }
    return positions;
};

  const handleScroll = () => {
    const mainScroll = mainScrollRef.current;
    const pageSnip = miniScrollRef.current;
    if (!mainScroll && !pageSnip) return;

    // page number changing pages top position wise
    const tempPositions = currentTopPosition();
    if(tempPositions && numPages > pgno){
      if(tempPositions[pgno] <= 300 && tempPositions[pgno] >= -600){
        setPgno(pgno + 1);
      }
    }
    if(pgno > 1 && tempPositions[pgno - 1] >= 400){
      setPgno(pgno - 1);
    }

    // if(topPosition && numPages > pgno){
    //   if((topPosition[pgno] - mainScroll.scrollTop) <= 200 && (topPosition[pgno] - mainScroll.scrollTop) >= -600){
    //     setPgno(pgno + 1);
    //   }
    // }
    // if(pgno > 1 && (topPosition[pgno - 1] - mainScroll.scrollTop) >= 400){
    //   setPgno(pgno - 1);
    // }

    // when the side page snippet was disapeared the the function to be exicute
    !scaleShow && changeScrollPosition()
 }

 const changeScrollPosition = (): void => {
  // for page snippet menu auto scrolling
  const miniHeight = miniDivRef.current?.clientHeight || 0; // Use optional chaining to avoid null reference
  const snipTop = (miniHeight * pgno) - miniHeight - 130;  
  if (miniScrollRef.current) {
      miniScrollRef.current.scrollTo({ top: snipTop, behavior: 'smooth' });
  }
};
  const get_page_snippets = () => {
    return [...Array(numPages)].map((_, index) => (
      <>
        <div key={index} className="p-3" ref={miniDivRef} style={{ border: pgno == index + 1 ? '1px solid rgb(154, 0, 201)' : 'none'}}>
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            scale={0.15}
            className="scroll-page"
           // onLoadSuccess={onPageLoadSuccess}
            renderTextLayer={false}
           // renderAnnotations={false}
            onClick={() =>handlePageSnippet(index + 1)}
          >
          </Page>
          <div className="is-size-7 has-text-centered mt-1">{index+1}</div>
        </div>
      </>
    ));
  };

  const get_main_pages = () => {
    return [...Array(numPages)].map((_, index) => (
      <>
        <div key={index} className="pb-5">
          <Page
            pageNumber={index + 1}
            scale={1}
            className="scroll-page"
           // ref={parentRef}
          //  onLoadSuccess={onPageLoadSuccess}
            renderTextLayer={false}
           // renderAnnotations={false}
          >
            {fieldBox}
          </Page>
        </div>
      </>
    ));
  };
 
  return (
    <>
    <div className="smart-pdf-box p-3">
      <Document file={pdfFile} onLoadSuccess={onDocumentLoadSuccess} onLoadProgress={onLoadProgress} >
        <div className={"columns "+bodyClass}>
          <span className="icon sidepage-move-btn" onClick={()=>setScaleShow(!scaleShow)}>
            <i className={`fa fa-caret-${scaleShow ? "right" : "left"} is-size-7`}></i>
          </span>
        { !scaleShow &&
          <div className="column pdf-pages is-2" ref={miniScrollRef}>
            {get_page_snippets()}
          </div> }
          <div className="column pdf-pages" onScroll={handleScroll} ref={mainScrollRef}>
            {get_main_pages()}
          </div>
        </div>
      </Document>
      <p className="pages-count">{pgno} / {numPages}</p>
    </div>
    </>
  );
};

export default ReactPdfViewer;



  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (!scrollRef.current) return; // Check if ref.current is not null
  //     // const currentScrollTop = scrollRef.current.scrollTop;

  //     const rect = pageRef.current.getBoundingClientRect();
  //     if(rect.top == 60){
  //       setPageNumber()
  //     }else {
  //       console.log("check", rect.top);
  //     }
      

  //     // while (Math.abs(currentScrollTop - lastScrollTop.current) >= 120) {
  //     //   if (currentScrollTop > lastScrollTop.current) {
  //     //     setPageNumber(value => value + 1)
  //     //     lastScrollTop.current += 100;
  //     //   } else if(currentScrollTop < lastScrollTop.current && pageNumber !== 1){
  //     //     setPageNumber(value => value - 1)
  //     //     lastScrollTop.current -= 100;
  //     //   }
  //     // }
  //   };

  //   const ref = scrollRef.current;
  //   if (ref) {
  //     ref.addEventListener('scroll', handleScroll);
  //   }

  //   return () => {
  //     if (ref) {
  //       ref.removeEventListener('scroll', handleScroll);
  //     }
  //   };
  // }, [scrollRef]);


     // const containerHeight = container.clientHeight;
    // const scrollTop = container.scrollTop;
    // const pageHeight = container.querySelector('.react-pdf__Page').clientHeight;
    // const newPageNo = Math.floor(scrollTop / (parseFloat(pageHeight)-20)) + 1;
    
    // if (newPageNo !== pageNumber) {
    //   setPageNumber(newPageNo);
    //   console.log("yy",newPageNo);
    // }